import { XIcon } from "@heroicons/react/outline";
import { useEffect, useState } from "react";
import { useLocation, useNavigate, matchPath } from "react-router-dom";

import { APP_ROUTES } from "const";
import { useProfileCompleteness } from "hooks";

const DISMISS_KEY = "profile-completion-banner-dismissed";

export function ProfileCompletionBanner() {
  const { isAuthenticated, isLoading, isComplete, missingLabels, userId } =
    useProfileCompleteness();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const [dismissed, setDismissed] = useState<boolean>(false);

  useEffect(() => {
    setDismissed(sessionStorage.getItem(DISMISS_KEY) === "true");
  }, []);

  // Hide on the profile page itself — user is already there
  const isOnProfilePage = !!matchPath(
    { path: APP_ROUTES.PROFILE, end: false },
    pathname
  );

  if (
    !isAuthenticated ||
    isLoading ||
    isComplete ||
    dismissed ||
    isOnProfilePage
  ) {
    return null;
  }

  const handleDismiss = () => {
    sessionStorage.setItem(DISMISS_KEY, "true");
    setDismissed(true);
  };

  const handleFinish = () => {
    navigate(`${APP_ROUTES.PROFILE}/${userId}`);
  };

  return (
    <div
      className="bg-amber-50 border-b border-amber-200 text-amber-900 px-5 py-3 relative text-sm"
      role="region"
      aria-label="Profile completion reminder"
    >
      <div className="max-w-5xl mx-auto flex items-center justify-between gap-3 pr-6">
        <p className="flex-1">
          <span className="font-semibold">Finish your profile.</span>{" "}
          Adding {missingLabels.join(", ")} helps people recognise your
          contributions and lets us connect you to relevant issues, solutions
          and action groups.{" "}
          <button
            type="button"
            onClick={handleFinish}
            className="underline font-semibold hover:text-amber-700"
          >
            Complete now
          </button>
        </p>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        className="absolute top-2 right-2 text-amber-700 hover:text-amber-900"
        aria-label="Dismiss"
      >
        <XIcon className="h-5 w-5" />
      </button>
    </div>
  );
}
